// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '@shared/utils/theme'

const WelcomePageTitleContainer = styled.div`
  margin: ${ props => props.margin };
  font-weight: bold;
  color: ${ theme.palette.dark_blue };
  font-size: 20px;
  line-height: 23px;
`

export default function WelcomePageTitle({ margin, label }) {
  return (
    <WelcomePageTitleContainer margin={ margin }>
      { label }
    </WelcomePageTitleContainer>
  )
}
